import type { PriceTable } from "@/lib/types";

/**
 * Separa as Tabelas Padrão (base do segmento, `defaultBase = true` — flag resolvido pelo backend)
 * das demais, preservando a ordem de entrada dentro de cada grupo. A tela fixa/destaca as padrão
 * no topo; a identidade vem do backend, nunca de heurística sobre o nome.
 */
export function partitionDefaultTables(tables: PriceTable[]): {
  defaults: PriceTable[];
  others: PriceTable[];
} {
  const defaults: PriceTable[] = [];
  const others: PriceTable[] = [];
  for (const table of tables) {
    (table.defaultBase ? defaults : others).push(table);
  }
  return { defaults, others };
}
